import React from "react";

import {
  FormLabel,
  FormInput,
  FormRadio,
  FormDateInput,
  FormTimeInput
} from "../../form";

export default props => {
  const { foodType } = props;

  const renderFoodFields = () => (
    <div>
      {foodType && foodType !== "breastMilk" && (
        <FormInput
          name="formulaDescription"
          labelRenderer={() => (
            <FormLabel for="formulaDescription" note="Optional">
              Describe Formula Type
            </FormLabel>
          )}
          maxLength={100}
        />
      )}

      <FormInput
        name="feedingTypeAmount"
        labelRenderer={() => (
          <FormLabel for="amount" note="Optional">
            Amount
          </FormLabel>
        )}
        measurement={"ml"}
        initialValue="100.0"
        type="number"
        maxLength={6}
      />

      <div className="form-input--centered">
        <FormDateInput
          name="date"
          labelRenderer={() => <FormLabel>Date</FormLabel>}
          dateFormat='MMM, dd yyyy'
        />

        <FormTimeInput
          name="startTime"
          labelRenderer={() => <FormLabel>Time</FormLabel>}
        />
      </div>
    </div>
  );

  return (
    <div>
      <FormLabel>Select Food</FormLabel>
        <div className="form-radio__group">
          <FormRadio 
            key="food.formula" 
            name="foodType" 
            value="formula" 
            box
          >
            Formula
          </FormRadio>

          <FormRadio 
            key="food.breastMilk" 
            name="foodType" 
            value="breastMilk" 
            box>
            Breast Milk
          </FormRadio>

          <FormRadio 
            key="food.both" 
            name="foodType" 
            value="both" 
            box
          å>
            Both
          </FormRadio>
        </div>
      {foodType && renderFoodFields()}
    </div>
  );
};
